<template>
  <screen-container>
    <div class="row ml-auto mr-auto login-form">
      <div class="col px-4">
        <img src="/img/userFake.png"  width="100%">
      </div>
      <div class="col mt-5">
        <div class="col-lg">
          <img src="/img/misionLogo.png" width="200">
        </div>
        <card type="login" plain>
          <fg-input
            class="no-border input-sm"
            addon-left-icon="fas fa-user"
            placeholder="Nombre de usuario"
            name="username"
            v-validate="'required'"
            :error="errors.first('username')"
            @keyup="errorMessage = ''"
            @keyup-enter="validateBeforeSubmit()"
            v-model="username"
          />

          <fg-input
            class="no-border input-sm"
            addon-left-icon="fab fa-keycdn"
            placeholder="Contraseña"
            type="password"
            name="password"
            v-validate="'required'"
            :error="errors.first('password')"
            @keyup="errorMessage = ''"
            @keyup-enter="validateBeforeSubmit()"
            v-model="password"
          />

          <alert
            type="danger"
            dismissible
            @dismiss="errorMessage = ''"
            :isVisible="errorMessage ? true : false"
          >
            <i class="fas fa-exclamation-circle"></i>
            <strong> ¡Ups!</strong>
            {{errorMessage}}
          </alert>
          
          <n-button
            type="primary"
            size="lg"
            round
            @click="validateBeforeSubmit()"
            :nprogress="submitted"
            :disabled="submitted"
            label="Acceder a Misión"
            icon-right="fas fa-sign-in-alt"
            nprogressLabel="Accediendo"
          />
          <br>
          <a class="link" :href="recoverPasswordUrl" target="blank">
            ¿Olvidaste tu contraseña?
          <br>
            Recuperar contraseña
          </a>
          <a class="collapse-item hidden" ref="link_to_dashboard" href="/"></a>
        </card>
      </div>
    </div>
  </screen-container>
</template>

<script>
import { ZoomCenterTransition } from 'vue2-transitions'
import { Card, Button, FormGroupInput } from '@/components';
import NProgress from 'nprogress';
import helpers from '../helpers';
import router from '../router';
import auth from '../services/Auth';

export default {
  name: 'login-page',
  bodyClass: 'login-page',
  async created() {
    NProgress.done();
  },
  components: {
    Card,
    ZoomCenterTransition,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  computed: {
    recoverPasswordUrl() {
      return `${process.env.VUE_APP_LOGIN_URL}?username=${this.username}`;
    },
  },
  data () {
    return {
      username: '',
      password: '',
      errorMessage: '',
      submitted: false,
      essentials: []
    }
  },
  methods: {
    async validateBeforeSubmit() {
      try {
        this.errorMessage = '';
        this.submitted = true;
        let validationResult = await this.$validator.validateAll();
				if (validationResult) {
          await auth.authenticate({
            username: this.username,
            password: this.password,
          });
          this.essentials = localStorage.getItem('essentials') ? localStorage.getItem('essentials').split(',') : [];
          if (this.essentials.length != 0) {
            const hasPreescolar = this.essentials.some(item => item.includes("Preescolar"));
            const hasPreeK = this.essentials.some(item => /(Pree-K|English)/.test(item));
            if (hasPreescolar && hasPreeK) {
              // console.log(`has preeschool - haspreek`);
              this.$router.push('/preek');
            }
            else if (hasPreescolar) {
              // console.log('only has preescolar');
              this.$router.push('/preschool'); 
            }
            else if (hasPreeK) {
              // console.log('only has preek');
              this.$router.push('/preek')
            } else {
              // console.log(`nothing essentials`);
              this.$refs.link_to_dashboard.click()
            }
          } else {
            console.log(`not essentials`);
            this.$refs.link_to_dashboard.click()
          }
        }
      } catch (error) {
        this.errorMessage = helpers.errors.getHumanErrorMessage(error, 'AUTHENTICATION');
      } finally {
        this.submitted = false;
      }
    }
  }
}
</script>
<style>
/* #app .login-form {
  padding-top: 6rem;
} */
@media (max-width: 730px) {
  .login-form {
    display: flex;
    flex-wrap: nowrap; 
  }
  .login-form img {
    max-width: 167px;
  }
}
</style>
